import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "email",
  "use": "email-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"email\">\n  <path d=\"M14.5489 16L22 22.3467L29.4511 16H14.5489ZM32 16.4822V30H12V16.4822V14H32V16.4822ZM30 18.1857L22 25L14 18.1857V28H30V18.1857Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol